import React, { useState } from 'react';
import { HelpCircle, ChevronDown } from 'lucide-react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "Is Trendrush a delivery app?",
      answer: "No. We're a tech and logistics platform for retailers. We provide complete digital infrastructure, logistics network, and data intelligence to transform retail businesses—not just move packages."
    },
    {
      question: "What technology do retailers get?",
      answer: "Complete online storefront, inventory management, order processing dashboard, customer relationship tools, and real-time analytics. No technical expertise needed."
    },
    {
      question: "How does data-as-a-service work?",
      answer: "We provide actionable insights about customer preferences, buying patterns, peak demand times, and product trends to help optimize inventory and planning."
    },
    {
      question: "What's the delivery time?",
      answer: "We leverage existing retail stores as local fulfillment centers for ultra-fast delivery in minutes."
    },
    {
      question: "How does try-and-buy work?",
      answer: "Order with confidence of easy returns and seamless refunds, just like shopping in a physical store."
    },
    {
      question: "What retailers can join?",
      answer: "All fashion retailers—apparel stores, footwear shops, accessories boutiques, multi-brand outlets. If you sell fashion products, Trendrush is for you."
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-coral-light rounded-full mb-6">
              <HelpCircle className="w-4 h-4 text-coral" />
              <span className="text-sm font-semibold text-coral">Frequently Asked Questions</span>
            </div>
            
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Got Questions?
              <span className="block text-coral mt-2">We've Got Answers</span>
            </h2>
            
            <p className="text-xl text-gray-600 leading-relaxed">
              Everything you need to know about Trendrush and how we're transforming retail
            </p>
          </div>

          {/* FAQ Accordion */}
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div 
                key={index}
                className="bg-gray-50 rounded-2xl border border-gray-100 px-6 hover:border-coral transition-colors overflow-hidden"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full flex items-center justify-between py-6 text-left text-lg font-semibold text-gray-900 hover:text-coral transition-colors"
                >
                  {faq.question}
                  <ChevronDown 
                    className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                <div 
                  className={`transition-all duration-300 ease-in-out ${
                    openIndex === index ? 'max-h-96 pb-6' : 'max-h-0'
                  }`}
                  style={{ 
                    overflow: 'hidden',
                    transition: 'max-height 0.3s ease-in-out'
                  }}
                >
                  <p className="text-gray-600 leading-relaxed text-base">
                    {faq.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Still Have Questions CTA */}
          <div className="mt-12 text-center p-8 bg-gradient-to-br from-gray-50 to-cream/30 rounded-2xl border border-gray-100">
            <h3 className="text-2xl font-bold text-gray-900 mb-3">
              Still have questions?
            </h3>
            <p className="text-gray-600 mb-6">
              Our team is here to help. Reach out and we'll get back to you quickly.
            </p>
            <a
              href="#contact"
              className="btn-primary inline-flex items-center"
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
